<div class="row pb-2 row-height">
  <h1 class="col-12">Privacy Policy</h1>
  <div class="contentbox">
    <div class="col-12" [innerHtml]="linkContent | keepHtml"></div>
  </div>
</div>
